<template>
  <div>
    <b-row class='mb-5' >
      <FormInput className='version' fieldName='created_at' :value='version.created_at' :canUpdate='false' :singleLine='true'/>
      <FormInput className='version' fieldName='updated_at' :value='version.updated_at' :canUpdate='false' :singleLine='true'/>
    </b-row>
    <b-row class='mb-5' >
      <FormInput className='version' fieldName='id' :value='version.id' :canUpdate='false'/>
    </b-row>
    <b-row class='mb-5' >
      <FormTextArea v-if='canReadField("description")' className='version' fieldName='Description' v-model='version.description' :canUpdate='canUpdateVersion("description")'/>
      <FormInput v-if='canReadField("post_upgrade_script_file")' className='version' fieldName='post_upgrade_script_file' v-model='version.post_upgrade_script_file' :canUpdate='canUpdateVersion("post_upgrade_script_file")'/>
    </b-row>
    <b-row class='mb-5' >
      <FormInput v-if='canReadField("version_text")' className='version' fieldName='Version Text' v-model='version.version_text' :canUpdate='canUpdateVersion("version_text")'/>
      <FormInput v-if='canReadField("version_number")' className='version' fieldName='Version Number' v-model='version.version_number' :canUpdate='canUpdateVersion("version_number")'/>
    </b-row>
    <b-row class='mb-5' >
      <FormInput v-if='canReadField("firmware_checksum")' className='version' fieldName='Firmware Checksum' v-model='version.firmware_checksum' :canUpdate='canUpdateVersion("firmware_checksum")'/>
      <FormInput v-if='canReadField("firmware_file_path")' className='version' fieldName='Firmware File Path' v-model='version.firmware_file_path' :canUpdate='canUpdateVersion("firmware_file_path")'/>
    </b-row>
    <b-row class='mb-5' >
      <FormInput v-if='canReadField("min_flowops_version")' className='version' fieldName='Min Flowops Verison' v-model='version.min_flowops_version' :canUpdate='canUpdateVersion("min_flowops_version")'/>
      <FormInput v-if='canReadField("max_flowops_version")' className='version' fieldName='Max Flowops Version' v-model='version.max_flowops_version' :canUpdate='canUpdateVersion("max_flowops_version")'/>
    </b-row>
    <b-row class='mb-5' >
      <FormSelect v-if='canReadField("manufacturer")' className='version' fieldName='Manufacturer' v-model='selectedManufacturer' :canUpdate='canUpdateVersion("manufacturer")' :options='manufacturers' @change='handleManufacturerChange' :required='false'/>
      <FormSelect v-if='canReadField("product") && this.products' className='version' fieldName='Product' v-model='selectedProduct' :canUpdate='canUpdateVersion("product")' :options='products' :required='false'/>
    </b-row>
    <b-row class='mb-5' align-h="end" >
        <b-button size='xs' variant='success' @click='handleLink'>Add</b-button>
    </b-row>
    <SearchResults v-if='hasProducts' :data='version.Products' className='version' :fields='fields' :actions='tableActions' :dataActions='tableDataActions' @clickAction='handleUnlink'/>
  </div>
</template>

<script>
  import rest from '@/common/tools/Rest';
  import abilityTester from '@/config/abilityTester';
  import FormInput from '@/components/form/Input';
  import FormSelect from '@/components/form/Select';
  import FormTextArea from '@/components/form/TextArea';
  import SearchResults from '@/components/search/Results';
  import { mapMutations } from 'vuex';
  import {ADD_ERROR, ADD_SUCCESS} from '@/store/MutationTypes';

  export default {
    name: 'VersionEdit',
    components:{
      FormInput,
      FormSelect,
      FormTextArea,
      SearchResults,
    },
    computed: {
      tableActions() {
        var actions = {
          unlink: {title: 'Unlink', icon: 'unlink'}
        };
        return actions;
      },
      tableDataActions() {
        var resp = [];
        for (var i = 0; i < this.version.Products.length; i++) {
          var actions = [];
          actions.push('unlink');
          resp.push(actions);
        }
        return resp;
      }
    },
    created(){
        this.setDefaults();
        var args = {
          //'filter': 'Manufacturers.status neq INACTIVE',
        }
        rest.get('manufacturer/', 'manufacturer', args).then(manufacturers => {
          let man = Array.isArray(manufacturers) ? manufacturers : [];
          for (let m of man) {
            this.manufacturers.push({'display': m.name, 'value': m.id});
          }
        }).catch(e => {
          this.error(rest.getErrorMessage(e));
        })
    },
    data() {
      return {
        manufacturers: [],
        selectedManufacturer: null,
        products: [],
        selectedProduct: null,

        fields: [
          {key: 'acronym', label: 'Product'},
          {key: 'Action', class: 'text-center'}
        ],
      }
    },
    props: {
      version: {}
    },
    methods: {
      ...mapMutations('messages', {
        alertSuccess: ADD_SUCCESS,
        error: ADD_ERROR
      }),
      _sortKeys(obj){
        if(typeof obj !== 'object' || Array.isArray(obj)){
          return obj;
        }
        var ordered = {};
        Object.keys(obj).sort().forEach((k) => {
          ordered[k] = this._sortKeys(obj[k]);
        });
        return ordered;
      },
      canReadField: function(field) {
        return abilityTester.can('read', 'version', {version_id: this.version.id}, field);
      },
      canUpdateVersion: function(field) {
        return this.canUpdate(this.version.id, field);
      },
      canUpdate(version_id,field){
        return abilityTester.can('update', 'version', {version_id: version_id}, field);
      },
      hasProducts() {
        return this.version.Products != [];
      },
      save() {
        var data = JSON.parse(JSON.stringify(this.version));
        var saveVersion = (data) => {
        this.$emit('entrypoint_wait_show','Saving...')
        rest.save('version', 'version', data).then(response => {
            for(var k in response){
              var val = response[k];
              this.$set(this.version, k, val);
            }
            this.VersionChanged();
            this.alertSuccess('Version Saved');
          }).catch(e => {
              this.error(rest.getErrorMessage(e));
          }).finally(() => {
            this.$emit('entrypoint_wait_hide');
          })
        }

        saveVersion(data);
      },
      VersionChanged(){
        this.$emit('UpdateVersion', this.version);
      },
      setDefaults(){
        if(!this.version.status){
          this.$set(this.version,'status', this.statuses.ACTIVE.value);
        }
      },
      updateConfig(newConfig){
        this.version['configuration_json'] = JSON.stringify(newConfig);
        this.VersionChanged();
      },
      handleManufacturerChange(){
        this.products = [];
        var args = {
          'filter': 'Products.status neq INACTIVE',
          'loading': 'Products'
        }
        rest.get('manufacturer/' + this.selectedManufacturer, 'manufacturer', args).then(response => {
          let pro = Array.isArray(response.Products) ? response.Products : [];
          for (let p of pro) {
            this.products.push({'display': p.acronym, 'value': p.id, 'acronym': p.acronym, 'id': p.id});
          }
        }).catch(e => {
          this.error(rest.getErrorMessage(e));
        })
      },
      handleLink() {
        for (let p of this.version.Products) {
          if (this.selectedProduct == p.id) {
            this.error("Product already associated with Version.")
            return;
          }
        }
        rest.patch('product/' + this.selectedProduct + '/version/' + this.version.id + '/link').then(() => {
          for (let p of this.products) {
            if (p.id == this.selectedProduct) {
              this.version.Products.push(p);
            }
          }
        }).catch(e => {
          this.error(rest.getErrorMessage(e));
        })
      },
      handleUnlink(_action, item, index) {
        rest.patch('product/' + item.id + '/version/' + this.version.id + '/unlink').then(() => {
          for (let p of this.version.Products) {
            if (p.id == item.id) {
              this.version.Products.splice(index, 1);
            }
          }
        }).catch(e => {
          this.error(rest.getErrorMessage(e));
        })
      },
    },
    mounted(){
    },
    watch: {
      version: function(){
        this.setDefaults();
      }
    },
  }
</script>
